var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkaleBotIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 60,
    viewBox: "0 0 62 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_331_130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.4746 0L58.6494 26.0871C61.7158 29.1433 61.7158 34.0983 58.6493 37.1544L38.0268 57.7079C34.9604 60.764 29.9888 60.764 26.9224 57.7079L6.2998 37.1544C3.2334 34.0983 3.2334 29.1433 6.29981 26.0871L32.4746 0Z",
    fill: "#30B3D5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.4074 28.1541C28.4546 28.1073 28.492 28.0516 28.5175 27.9903C28.5431 27.929 28.5562 27.8634 28.5562 27.797C28.5562 27.7307 28.5431 27.665 28.5175 27.6037C28.492 27.5425 28.4546 27.4868 28.4074 27.4399L22.0127 21.0842L15.618 27.4394C15.5229 27.5342 15.4695 27.6625 15.4695 27.7963C15.4695 27.9302 15.5229 28.0585 15.618 28.1533L17.4582 29.9822L22.0127 25.4563L26.5671 29.9835L28.4074 28.1541Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3461 28.1541C49.3933 28.1073 49.4307 28.0516 49.4563 27.9903C49.4818 27.929 49.495 27.8634 49.495 27.797C49.495 27.7307 49.4818 27.665 49.4563 27.6037C49.4307 27.5425 49.3933 27.4868 49.3461 27.4399L42.9514 21.0842L36.5567 27.4394C36.4617 27.5342 36.4083 27.6625 36.4083 27.7963C36.4083 27.9302 36.4617 28.0585 36.5567 28.1533L38.397 29.9822L42.9514 25.4563L47.5059 29.9835L49.3461 28.1541Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_331_130",
    x: 0,
    y: 0,
    width: 64.9492,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_331_130"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_331_130",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkaleBotIcon);
export default __webpack_public_path__ + "static/media/skaleBotIcon.abbadc0919c71173f6ab4a35fcfe28c1.svg";
export { ForwardRef as ReactComponent };